var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "DIV",
    { staticClass: "badge border" },
    [
      _c("ItpIcon", { attrs: { icon: "ic:baseline-currency-exchange" } }),
      _vm._v(" "),
      _c("span", [_vm._v("\n    " + _vm._s(_vm.value.anchor) + "\n  ")]),
      _vm._v(" "),
      _vm.value.description
        ? _c("span", [
            _vm._v("\n    " + _vm._s(_vm.value.description) + "\n  ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.source
        ? _c(
            "span",
            { staticClass: "ml-2" },
            [
              _c("ItpIcon", { attrs: { icon: "ic:baseline-cable" } }),
              _vm._v(" "),
              _c("span", [_vm._v("\n      " + _vm._s(_vm.source) + "\n    ")])
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }